
import { useEffect, useRef, useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import { validateAddPriceListForm } from '../../validation/Authentication/Validation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';
const MidAddProductPriceList = (type) => {
    const { navigateDashboard } = Navigations();
    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [distributors, setDistributors] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [productVariants, setProductsVariant] = useState([]);
    const [products, setProducts] = useState([]);
    const [isIndian, setisIndian] = useState(null);

    const [values, setValue] = useState({
        priceListType: 'state',
        country: null,
        state: null,
        distributor: null,
        variants: [{ productId: null, variantId: null, price: '' }]
    });

    useEffect(() => {
        const fetchData = async () => {
            showToast('', '');
            await getDistributors();
            if (Array.isArray(users) && users.length > 0) {
                const currentUser = users[0];
                const userTypes = currentUser['UserType'];
                const usertypeArray = typeof userTypes === 'string'
                    ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num))
                    : [];
                const hasOne = usertypeArray.includes(1);
                const hasTwo = usertypeArray.includes(2);
                const isPersonal = currentUser['IsPersonalDetils'] === 1;
                if (type === 'seller' && isPersonal && hasOne && hasTwo) {
                    if (currentUser['IsIndian'] === 0) {
                        setisIndian(false);
                        await getCountries();
                    } else {
                        setisIndian(true);
                        await getstates(101);
                    }
                    StopLoading(setisLoading);
                } else {
                    navigateDashboard('buyer');
                }

                await Getproducts();
            }
        };

        fetchData();
    }, [users, type]);

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddPriceListForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue({
        priceListType: 'state',
        country: null,
        state: null,
        distributor: null,
        variants: [{ productId: null, variantId: null, price: '' }]
    })
        setValue(prevValues => {
            const newValues = { ...prevValues, [name]: value };
            if (Object.keys(validateAndSetErrors(newValues)).length === 0) {
                clearAllErrors();
            }
            return newValues;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
            StopLoading(setisLoading)
            clearAllErrors();
            // SubmitCategory();
        }
    };
    const handleSelectChange = (name, selectedOption) => {
        setValue(prev => ({
            ...prev,
            [name]: selectedOption
        }));
    };

    const handleProductChange = (index, field, value) => {
        const updatedProduct = [...values.variants ];
        updatedProduct[index] = { ...updatedProduct[index], [field]: value };
        updatedProduct[index].variantId = null;  
        updatedProduct[index].price = '';  
        setValue(prev => ({ ...prev, variants: updatedProduct }));
        GetproductVariants(value);
    };

    const handleVariantChange = (index, field, value) => {
        const updatedVariants = [...values.variants];
        updatedVariants[index] = {
            ...updatedVariants[index],
            [field]: value
        };
        setValue(prev => ({
            ...prev,
            variants: updatedVariants
        }));
    };

    const addVariant = () => {
        setValue(prev => ({
            ...prev,
            variants: [...prev.variants, { productId: null, variantId: null, price: '' }]
        }));
    };

    const removeVariant = (index) => {
        if (values.variants.length > 1) {
            const updatedVariants = [...values.variants];
            updatedVariants.splice(index, 1);
            setValue(prev => ({
                ...prev,
                variants: updatedVariants
            }));
        }
    };

    const handleGetState = (country) => {
        setValue(prevValues => ({ ...prevValues, country: country.value }));
        getstates(country);
    }
    const handleGetCities = (states) => {
        setValue(prevValues => ({ ...prevValues, state: states.value }));
    }

    const getCountries = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcountries`,).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(country => ({
                        label: country.name,
                        value: country.id,
                    }));
                    setCountryData(transformedData);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => { });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find countries, please try again later ", 'error');
        }
    };

    const getstates = async (country_id) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getstates`, { countryid: country_id, }).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(state => ({
                        label: state.name,
                        value: state.id,
                    }));

                    setStateData(transformedData);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find cities, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find States, please try again later ", 'error');
        }
    };

    const getDistributors = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetAllDistributors`, { app: 0 }, { withCredentials: true })
                .then((response) => {
                    StopLoading(setisLoading);
                    if (response.data.success === 1) {
                        const distributorData = response.data.data;
                        setDistributors(distributorData.map(p => ({ value: p.distributor_id, label: p.full_name })));
                        // setDistributors(distributorData.map(p => ({ value: p.id, label: p.full_name }))); // Newlast change 6-8-25
                    }
                    else if (response.data.success === 0) {
                        StopLoading(setisLoading);
                        showToast(response.data.message, 'error');
                    }
                }).catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find seller details, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find seller details, please try again later ", 'error');
        }
    }

    const Getproducts = async () => {
        StartLoading(setisLoading);
        try {
            // productUinqueID: uniqueID, app: 0 
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getproducts`, {}, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        setisLoading(false);
                        const productData = res.data.data;
                        setProducts(productData.map(p => ({ value: p.product_unique_id, label: p.product_name , status:p.status })));
                    }
                    else {

                    }
                })
                .catch((err) => {
                    setisLoading(false);
                    if (err.response) {
                        // console.error('Server responded with a status:', err.response.status);
                        // console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        // console.error('No response received:', err.request);
                    } else {
                        // console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            setisLoading(false);
            showToast("Failed to Get Products, please try again later ", 'error');
        }
    }

    const GetproductVariants = async (uniqueID) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductVariant`, { productUinqueID: uniqueID.value, app: 0 }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        setisLoading(false);
                        const productVariantData = res.data.data;
                        setProductsVariant(productVariantData.map(p => ({ value: p.variant_unique_id, label: p.product_variant })));

                    }
                    else {
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        // console.error('Server responded with a status:', err.response.status);
                        // console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        // console.error('No response received:', err.request);
                    } else {
                        // console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to Get Product Variant, please try again later ", 'error');
        }
    }
    const handleProductPriceListSubmit = () => {
        AddProductPriceListSubmit();
    }
    const AddProductPriceListSubmit = async () => {


       if (values.priceListType === 'state') {
         if (!values.state) {
           StopLoading(setisLoading);
           showToast("Please select state", "error");
           return;
         }
        }
        
       if (values.priceListType === 'distributor') {
          if (!values.distributor) {
             StopLoading(setisLoading);
            showToast("Please select distributor", "error");
            return;
          }
        } 

        if (!values.variants || values.variants.length === 0) {
          StopLoading(setisLoading);
          showToast("Please add at least one Price List", "error");
          return;
       }
     
      const invalidVariantIndex = values.variants.findIndex((variant) => {
        return (
            !variant.productId ||     
            !variant.variantId ||   
            variant.price === "" ||  
            variant.price === null ||
            Number(variant.price) <= 0 
        );
        });

            if (invalidVariantIndex !== -1) {
            StopLoading(setisLoading);
            showToast(
                `Please fill all fields in Variant #${invalidVariantIndex + 1}`,
                "error"
            );
            return;
            }

           StartLoading(setisLoading);
        // If all validations pass, make API call
        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddProductPricelist`,
                { values, app: 0 },
                { withCredentials: true, validateStatus: () => true, }
            );

            StopLoading(setisLoading);

            const resData = response?.data;
            if (resData?.success === 1) {
                showToast(resData.message, 'success');
                setValue({
                    priceListType: 'state',
                    country: null,
                    state: null,
                    distributor: null,
                    variants: [{ productId: null, variantId: null, price: '' }]
                })

            } else {
                showToast(resData?.message || 'Something went wrong', 'error');

                setValue({
                    priceListType: 'state',
                    country: null,
                    state: null,
                    distributor: null,
                    variants: [{ productId: null, variantId: null, price: '' }]
                })
            }
        } catch (err) {
            StopLoading(setisLoading);
            console.error("Caught Error from API:", err);

            const status = err?.response?.status;
            const message = err?.response?.data?.message || 'Something went wrong in catch block';

            if (status === 400) {
                showToast(message, 'error'); // ✅ yahi chalega jab API "Price already exists..." bhejti hai
            } else if (status === 401) {
                showToast('Unauthorized access', 'error');
            } else if (!err.response) {
                showToast("Network or CORS issue: " + err.message, 'error');
            } else {
                showToast(message, 'error');
            }
        }

    };
    return { values, users, userPlan, Remainuser, subUser, handleChange, handleSubmit, isLoading, countryData, stateData, handleGetCities, handleGetState, distributors, handleVariantChange, handleProductChange, addVariant, removeVariant, products, productVariants, handleSelectChange, handleProductPriceListSubmit }
}

export default MidAddProductPriceList